// import router from 'vue-router'
import Vue from 'vue';


const actions = {
  saveCurrentUnload: ({getters}, payload) => {

    let currentUnload = {
      ...getters.getCurrentUnloading,
      locationId: parseInt(payload.location),
       endTime: new Date(),
      trigger: 'userUnload'
    };

    return Vue.prototype.$FB
        .collection('incoming-products')
        .add(currentUnload);

  },
  checkIfBarcodeIsWayOfTransportation: ({rootGetters}, payload) => {
    // console.log('getting trailer or truck number for ' + payload)
    return _.filter(rootGetters['incomingCargo/getIncomingCargos'],incomingCargo => {

      if (incomingCargo.trailerNumber === payload) {
        return incomingCargo
      } else if (incomingCargo.truckNumber === payload) {
        return incomingCargo;
      } else {

      }
    });
  },
  checkIfBarcodeIsLocation: ({rootGetters}, payload) => {
    console.log(rootGetters['locations/getLocation'](payload),payload)
    return rootGetters['locations/getLocation'](payload);
  }
};

export default actions;

